import React from 'react';
import PropTypes from 'prop-types';
import images from '../../../assets/images';
import { Field } from 'formik';

const PublicVisibilityToggle = ({
    children,
    label,
    groupName,
    visibilityFieldName,
    value
}) => {
    return (
        <div className="box-wrapper">
            <label htmlFor={groupName}>{label}</label>
            <div className="box">
                <div className="radio-tile-group">
                    <div className="input-container">
                        <Field
                            type="radio"
                            id={`public-${groupName}`}
                            name={visibilityFieldName}
                            className="radio-button"
                            checked={value === '0' || value === false}
                            value="0"
                        />
                        <div className="radio-tile">
                            <div className="ico">
                                <img src={images.lockopen} alt="" />
                            </div>
                            <label
                                htmlFor={visibilityFieldName}
                                className="radio-tile-label">
                                Public
                            </label>
                        </div>
                        <small className="subtext">Anyone</small>
                    </div>

                    <div className="input-container">
                        <Field
                            type="radio"
                            id={`private-${groupName}`}
                            name={visibilityFieldName}
                            className="radio-button"
                            checked={value === '1' || value === true}
                            value="1"
                        />
                        <div className="radio-tile">
                            <div className="ico">
                                <img src={images.lock} alt="" />
                            </div>
                            <label
                                htmlFor={visibilityFieldName}
                                className="radio-tile-label">
                                Private
                            </label>
                        </div>
                        <small className="subtext">Followers</small>
                    </div>
                </div>

                <div className="wrapper-100">
                    <div className="form-input">{children}</div>
                </div>
            </div>
        </div>
    );
};

PublicVisibilityToggle.propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    groupName: PropTypes.string,
    visibilityFieldName: PropTypes.string,
    value: PropTypes.string
};
export default PublicVisibilityToggle;
